import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  LayoutDashboard,
  MessageCircle,
  Calendar,
  Route,
  User,
} from "lucide-react";

const NAV_ITEMS = [
  { icon: LayoutDashboard, label: "Inicio", href: "/dashboard" },
  { icon: Calendar, label: "Eventos", href: "/events" },
  { icon: Route, label: "Rutas", href: "/routes" },
  { icon: MessageCircle, label: "Chat", href: "/chat" },
  { icon: User, label: "Perfil", href: "/profile" },
];

export function BottomNav() {
  const { pathname } = useLocation();

  // Hide on ride mode & fullscreen pages
  if (pathname === "/ride" || pathname === "/" || pathname === "/auth" || pathname.startsWith("/onboarding") || pathname === "/reset-password" || pathname === "/privacy") {
    return null;
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-xl border-t border-border/60">
      <div className="max-w-md md:max-w-2xl lg:max-w-4xl mx-auto flex items-stretch justify-around safe-area-inset-bottom">
        {NAV_ITEMS.map((item) => {
          const isActive =
            pathname === item.href ||
            (item.href !== "/dashboard" && pathname.startsWith(item.href));
          const Icon = item.icon;

          return (
            <Link
              key={item.href}
              to={item.href}
              className="relative flex flex-col items-center justify-center flex-1 py-2.5 transition-colors"
            >
              {isActive && (
                <motion.div
                  layoutId="bottomnav-indicator"
                  className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[3px] rounded-b-full bg-primary"
                  style={{ boxShadow: "0 2px 12px hsl(var(--primary) / 0.5)" }}
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                />
              )}
              <Icon
                className={`w-5 h-5 transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`}
              />
              <span
                className={`text-[10px] font-mono mt-0.5 transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
